import { render, staticRenderFns } from "./upgrade_rule_and.vue?vue&type=template&id=d6b6d508&scoped=true"
import script from "./upgrade_rule_and.vue?vue&type=script&lang=js"
export * from "./upgrade_rule_and.vue?vue&type=script&lang=js"
import style0 from "./upgrade_rule_and.vue?vue&type=style&index=0&id=d6b6d508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b6d508",
  null
  
)

export default component.exports